// extracted by mini-css-extract-plugin
export default {"prevalence-by-community":"nulPB985hCqMNrOeJmh9"};